<template>
  <div class="modal fade short-code-modal-background" id="shortcode-list-modal" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog" >
    <div class="modal-dialog modal-simple modal-md modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">{{ $t('short_code_names.modal_title') }}</h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeAndOpenModals()">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <ul class="nav nav-tabs d-flex flex-column" id="short-codes-tabs" role="tablist">
            <li class="nav-item" v-if="shortCodes.length > 0 && !fromCustomShortCode">
              <a class="nav-link active" id="custom-tab" data-toggle="tab" href="#custom" role="tab" aria-controls="custom" aria-selected="true">{{ $t('short_code_names.custom') }}</a>
            </li>
            <li class="nav-item">
              <a :class="(shortCodes.length === 0) || (shortCodes.length > 0 && fromCustomShortCode) ? 'active nav-link': 'nav-link'" id="rental-tab" data-toggle="tab" href="#rental" role="tab" aria-controls="rental" aria-selected="false">{{ $t('short_code_names.rental') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="guest-tab" data-toggle="tab" href="#guest" role="tab" aria-controls="guest" aria-selected="false">{{ $t('short_code_names.guest') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="inquiry-tab" data-toggle="tab" href="#inquiry" role="tab" aria-controls="inquiry" aria-selected="false">{{ $t('short_code_names.inquiry') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="booking-tab" data-toggle="tab" href="#booking" role="tab" aria-controls="booking" aria-selected="false">{{ $t('short_code_names.booking') }}</a>
            </li>
            <li class="nav-item" v-if="actionOccurId && [9, 10, 11, 16].includes(actionOccurId)">
              <a class="nav-link" id="payment-tab" data-toggle="tab" href="#payment" role="tab" aria-controls="payment" aria-selected="false">{{ $t('short_code_names.payment_link') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="auto-payment-tab" data-toggle="tab" href="#auto-payment" role="tab" aria-controls="auto-payment" aria-selected="false">{{ $t('short_code_names.auto_payment') }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="custom" role="tabpanel" aria-labelledby="custom-tab" v-if="shortCodes.length > 0 && !fromCustomShortCode">
              <div class="d-flex flex-column short-code-container">
                <div v-for="(shortcode, index) in shortCodes" class="short-code-item">
                  <div class="radio-custom radio-primary" v-if="shortCodes.length > 0">
                    <input type="radio" :id="`custom-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                    <label class="control-label custom-short-code-label" :for="`custom-${index}`">{{ shortcode.title }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div :class="shortCodes.length === 0 || (shortCodes.length > 0 && fromCustomShortCode) ? 'active tab-pane': 'tab-pane'" id="rental" role="tabpanel" aria-labelledby="rental-tab">
              <div class="d-flex flex-column short-code-container">
                <div v-for="(shortcode, index) in rentalShortcodes" class="short-code-item">
                  <div class="radio-custom radio-primary">
                    <input type="radio" :id="`rentalShortcodes-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                    <label class="control-label" :for="`rentalShortcodes-${index}`">{{ shortcode[shortCodeName] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="guest" role="tabpanel" aria-labelledby="guest-tab">
              <div class="d-flex flex-column short-code-container">
                <div v-for="(shortcode, index) in guestShortcodes" class="short-code-item">
                  <div class="radio-custom radio-primary">
                    <input type="radio" :id="`guestShortcodes-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                    <label class="control-label" :for="`guestShortcodes-${index}`">{{ shortcode[shortCodeName] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="inquiry" role="tabpanel" aria-labelledby="inquiry-tab">
              <div class="d-flex flex-column short-code-container">
                <div v-for="(shortcode, index) in inquiryShortcodes"  class="short-code-item">
                  <div class="radio-custom radio-primary">
                    <input type="radio" :id="`inquiryShortcodes-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                    <label class="control-label" :for="`inquiryShortcodes-${index}`">{{ shortcode[shortCodeName] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="booking" role="tabpanel" aria-labelledby="booking-tab">
              <div class="d-flex flex-column short-code-container">
                <div v-for="(shortcode, index) in bookingShortcodes" class="short-code-item">
                  <div class="radio-custom radio-primary">
                    <input type="radio" :id="`bookingShortcodes-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                    <label class="control-label" :for="`bookingShortcodes-${index}`">{{ shortcode[shortCodeName] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="payment" role="tabpanel" aria-labelledby="payment-tab">
              <div class="d-flex flex-column short-code-container" v-if="actionOccurId && [9, 10, 11, 16].includes(actionOccurId)">
                <div v-for="(shortcode, index) in paymentLinkShortcodes"  class="short-code-item">
                  <div class="radio-custom radio-primary">
                    <input type="radio" :id="`paymentLinkShortcodes-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                    <label class="control-label" :for="`paymentLinkShortcodes-${index}`">{{ shortcode[shortCodeName] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="auto-payment" role="tabpanel" aria-labelledby="auto-payment-tab">
              <div class="d-flex flex-column short-code-container">
                <div v-for="(shortcode, index) in autoPaymentShortcodes" class="radio-custom radio-primary">
                  <input type="radio" :id="`autoPaymentShortcodes-${index}`" name="shortcodes" class="shortcode-code" :value="shortcode.code" v-model="mainSelectedShortCode">
                  <label class="control-label" :for="`autoPaymentShortcodes-${index}`">{{ shortcode[shortCodeName] }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="action-buttons-container d-flex justify-content-center">
          <button class="cancel btn waves-effect waves-classic btn-cancel" @click.prevent="closeAndOpenModals()">{{ $t("button.cancel") }}</button>
          <button class="btn btn-primary waves-effect waves-classic btn-save btn waves-effect waves-classic btn-save" @click.prevent="insertShortcodeToText()">{{ $t("button.insert") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import mixin from '../../mixins/mixin';
    import shortCodes from '../../mixins/shortCodes';
    import automationService from '../../services/automation';

    export default {
      name: 'ShortCodeListModal',
      data() {
        return {
          shortCodes: [],
          mainSelectedShortCode: this.selectedShortCode
        }
      },
      props: {
        'actionOccurId': {
            default: null,
            type: Number
        },
        'selectedShortCode': '',
        'shortCodeName': '',
        'fromCustomShortCode': false
      },
      mixins: [ mixin, shortCodes ],
      async mounted() {
        await automationService.getCustomShortCodes(this);
        $('.nav-link').mouseleave(function () {
          $(this).css({"border": "none"});
        });
      },
      methods: {
        async insertShortcodeToText() {
          await this.$emit('changeSelectedShortCode', this.mainSelectedShortCode);
          await this.$emit('insertShortcodeToText');
        },
        closeAndOpenModals() {
          this.$emit('closeAndOpenModals');
        }
      }
    }
</script>

<style>
  #shortcode-list-modal .tab-content, #shortcode-list-modal .tab-content>.active{
    width:100% !important;
  }
  #shortcode-list-modal .tab-content>.active{
    overflow:auto;
  }
</style>


// WEBPACK FOOTER //
// ShortCodeListModal.vue?122fff64